/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        SiteCalendar.js
//   Object:     SiteCalendar
//   Details:    SiteCalendar Component
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 84474  26/09/19 JC  M01  Need to URI decode the site
// 103839 06/04/20 JC  M02  React upgrade
// 111318 23/12/20 JC  M03  componentWillReceiveProps should have been removed in M02
//-------------------------------------------------------
*/

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { weeksActions } from '../store/Weeks';
import Header from '../components/Header';
import Loading from '../components/Loading';
import NoItems from '../components/NoItems';
import Calendar from '../components/Calendar';
import AlertPanel from '../components/AlertPanel';

class SiteCalendar extends Component {

	constructor(props) {
		super(props);

		this.state = {
			siteId: undefined,
			year: undefined,
			month: undefined
		};
	}

  //M03 simply not needed as handled in getDerivedStateFromProps
  //  //M02 componentWillMount
  //  componentDidMount() {
		//// This method runs when the component is first added to the page
		//const { siteId, year, month } = this.props.match.params;

		//this.setState({
		//	siteId: siteId,
		//	year: year,
		//	month: month
		//});

		//this.props.getWeeks(siteId, year, month);
  //}

  //M03 re-written below
	//componentWillReceiveProps(nextProps) {
	//	const { siteId, year, month } = nextProps.match.params;
	//	const state = this.state;

	//	if (siteId !== state.siteId || year !== state.year || month !== state.month) {
	//		this.setState({
	//			siteId: siteId,
	//			year: year,
	//			month: month
	//		});
	//		this.props.getWeeks(siteId, year, month);
	//	}
 // }

  //M03
  static getDerivedStateFromProps(props, state) {

    //get values from props
    let siteId = props.match.params.siteId;
    let year = props.match.params.year;
    let month = props.match.params.month;

    //change of props?
    if (siteId !== state.siteId || year !== state.year || month !== state.month) {
        
      //get weeks
      props.getWeeks(siteId, year, month);

      //return new state
      return ({
        siteId: siteId,
        year: year,
        month: month
      });
    }

    // Return null to indicate no change to state.
    return null;
  }

	render() {
		const { isLoading, weeks, year, month } = this.props;
        const { siteId, site } = this.props.match.params;

        //M01 decode the site
        var decodedSite = decodeURIComponent(site);

        ;
		return (
            <div>
                {/* M01 use decoded site */}
                <Header title={decodedSite} /> 

				<div>
					{this.props.error ? <AlertPanel type="danger" message={this.props.error} /> : []}

					{isLoading ? <Loading /> : []}
					{!isLoading && (weeks === undefined || weeks.length === 0)
                        ? <NoItems />
                        /* M01 use decoded site */
                        : <Calendar siteId={siteId} site={decodedSite} weeks={weeks} year={year} month={month} />
					}
				</div>
			</div>
		);
	}
}

SiteCalendar.propTypes = {
	weeks: PropTypes.arrayOf(PropTypes.any),
	error: PropTypes.string,
	isLoading: PropTypes.bool
};

export default connect(
	state => state.weeks,
	dispatch => bindActionCreators(weeksActions, dispatch)
)(SiteCalendar);
